import GoogleMap from "./map.js";

// ( function () {
const mapDiv = document.getElementById("map");

let searchSection = document.getElementsByClassName('section-specialists')[0].cloneNode(true);

var updateMap = () => {
	if (document.getElementById('mapRegion').value &&
		document.getElementById('mapCategory').value) {
		let page_type = document.getElementById('page_type').value

		return window.axios.get(
			"/wp-json/wp/v2/retailer", 
			{
				params: {
					location: document.getElementById('mapRegion').value,
					[page_type]: document.getElementById('mapCategory').value
				}
			}
		)
	} else {
		return null;
	}
}

var updateResults = () => {
	if (document.getElementById('mapRegion').value &&
		document.getElementById('mapCategory').value) {
		let page_type = document.getElementById('page_type').value

		return $.ajax(retailers.ajaxurl, {
			type: "POST",
			data: {
				action: 'filter_retailers',
				location: document.getElementById('mapRegion').value,
				[page_type]: document.getElementById('mapCategory').value
			},
			dataType: "html"
		});
	} else {
		return null;
	}
}

$('.map-filter-options').on('change', function () {
	filterRetailers();   
});

$(function() {
	const mapCanvas = new google.maps.Map(mapDiv, { zoom: 5 });
	const map = new GoogleMap([], mapCanvas);
	map.initMap();

	if(mapDiv.hasAttribute('data-type') && mapDiv.dataset.type == 'all') {
		let allPins = window.axios.get(
			"/wp-json/wp/v2/retailer", 
			{
				params: { 
					has_services: 1
				}
			}
		);

		$.when( allPins ).then(function (pins) {
			updateMapPins(pins);
		}).catch(err => {
			console.error(err)
		})
	}

	function displayLocation(latitude, longitude) {      
		var geocoder = new google.maps.Geocoder();
		var latlng = new google.maps.LatLng(latitude, longitude);
	
		geocoder.geocode({ 'location': latlng }, function (results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				for (var i = 0; i < results[0].address_components.length; i++) {
					for (var b = 0; b < results[0].address_components[i].types.length; b++) {
						if (results[0].address_components[i].types[b] == "administrative_area_level_1") {
							var city = results[0].address_components[i];
							$("#mapRegion option:contains(" + city.short_name + ")").attr('selected', true);
							filterRetailers();
							break;
						}
					}
				}

			} else {
				alert('Geocode was not successful for the following reason: ' + status);
			}
		});
	};

	var successCallback = function (position) {
		var x = position.coords.latitude;
		var y = position.coords.longitude;      
		displayLocation(x, y);
	};

	var errorCallback = function (error) {
		var errorMessage = 'Unknown error';
		switch (error.code) {
			case 1:
				errorMessage = 'Permission denied';
				break;
			case 2:
				errorMessage = 'Position unavailable';
				break;
			case 3:
				errorMessage = 'Timeout';
				break;
		}      
		console.log(errorMessage);
	};

	var options = {
		enableHighAccuracy: false,
		timeout: 10000
	};

	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options);
	}
});

function filterRetailers() {

	// GA
	try {
		if (document.getElementById('mapRegion').value &&
			document.getElementById('mapCategory').value) {
			var category = document.getElementById("mapCategory");
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'where_to_buy_search',
				where_to_buy_location: document.getElementById('mapRegion').value,
				where_to_buy_category: category.options[category.selectedIndex].text
			});
		}
	}
	catch (err) {
		if (window.console) {
			console.log(err);
		}
	}

	if (document.getElementById('mapRegion').value &&
		document.getElementById('mapCategory').value) {
		$.when(
			updateMap(),
			updateResults()
		).then(function (pins, retailers) {
			// Update retailer results
			$('#retailer-filter-results').html(retailers ? retailers[0] : searchSection);

			$('[data-toggle="popover"]').popover({
				html: true
			});
			
			// Update map pins
			if (pins && pins.data) {
				updateMapPins(pins);

				// $('#close-mobile-filter').trigger('click');
				$('#wtbFilterAcc').collapse('hide');
			}
		}).catch(err => {
			console.error(err)
		})
	}
}

function updateMapPins(pins) {
	if (pins && pins.data) {
		if (pins.data.length === 1) {
			var pin = pins.data[0];

			const rinnaiLatLng = { "lat": pin.acf.fw_retailer_contact_information.fw_retailer_google_map.lat, "lng": pin.acf.fw_retailer_contact_information.fw_retailer_google_map.lng };
			const mapCanvas = new google.maps.Map(mapDiv, { zoom: 12, center: rinnaiLatLng });
			const map = new GoogleMap(pins.data, mapCanvas);
			map.initMap();
		} else {
			const mapCanvas = new google.maps.Map(mapDiv, { zoom: 5 });
			const map = new GoogleMap(pins.data, mapCanvas);
			map.initMap();
		}
	}
}
// } )();